import React, { useState, useEffect, useContext } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import axios from "axios";
import StatusActive from "../../../components/constants/StatusActive";
import Layout from "../../../components/common/Layout";
import Modal from "react-bootstrap/Modal";
import Alerts from "../../layout/Alerts";
import AlertContext from "../../../context/alert/alertContext";
import checkTime from "../../../components/constants/CheckTime"

const NameView = props => {
  const pagePermission =
      JSON.parse(localStorage.getItem("permission")) === null
      ? {IsCreate: false,
        IsDelete: false,
        IsUpdate: false,
        IsView: false}
      : JSON.parse(localStorage.getItem("permission")).filter(c => parseInt(c.MenuId) === 5)[0];
  const [addressesData, setAddressesData] = useState([]);
  const nameId = props.match.params.id;
  const userId =
    JSON.parse(localStorage.getItem("user")) === null
      ? null
      : JSON.parse(localStorage.getItem("user"))[0].Id;
  const alertContext = useContext(AlertContext);
  const { setAlert } = alertContext;
  const [showDeleteName, setShowDeleteName] = useState(false);
  const [showDeleteAdd, setShowDeleteAdd] = useState({
    addId: "",
    showPop: false
  });
  const [showAddAddress, setShowAddAddress] = useState({
    show: "",
    showPop: false,
    addressId: ""
  });
  const [showConfirmAddress, setShowConfirmAddress] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    code: "",
    phone: "",
    addr: "",
    fax: "",
    email: "",
    remark: "",
    taxID: "",
    initial: ""
  });
  const [addressFormData, setAddressFormData] = useState({
    namesId: nameId,
    addressType: "",
    address: "",
    telephone: "",
    fax: "",
    remark: "",
    createBy: userId
  });
  const { addressType, address, telephone, fax, remark } = addressFormData;
  const AddressOnChange = e =>
    setAddressFormData({ ...addressFormData, [e.target.name]: e.target.value });
  const addressesColumn = [
    {
      cell: row => (
        <div>
          <button
            hidden={!pagePermission.IsUpdate}
            className="btn btn-sm btn-primary ml-2"
            type="button"
            onClick={() => {
              setShowAddAddress({
                show: "Edit",
                showPop: true,
                addressId: row.NamesAddressId
              });
            }}
          >
            <i className="fa fa-pencil"></i> Edit
          </button>
          <button
            hidden={!pagePermission.IsDelete}
            className="btn btn-sm btn-danger ml-2"
            type="button"
            onClick={() => {
              setShowDeleteAdd({ addId: row.NamesAddressId, showPop: true });
            }}
          >
            <i className="fa fa-remove"></i> Delete
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      width: "180px",
      button: true
    },
    {
      name: "Type",
      selector: "AddressType",
      sortable: true,
      width: "150px",
      wrap: true
    },
    {
      name: "Address",
      selector: "Address",
      width: "350px",
      sortable: true,
      wrap: true
    },
    {
      name: "Telephone",
      selector: "Telephone",
      sortable: true,
      wrap: true
    },
    {
      name: "Fax",
      selector: "Fax",
      sortable: true,
      wrap: true
    },
    {
      name: "Remark",
      selector: "Remark",
      width: "350px",
      sortable: true,
      wrap: true
    },
    {
      name: "Status",
      selector: "StatusActive",
      width: "100px",
      sortable: true,
      cell: row => (
        <div>
          {StatusActive.InActive === row.StatusActive && (
            <h6>
              <span className="badge badge-danger text-left">InActive</span>
            </h6>
          )}
          {StatusActive.Active === row.StatusActive && (
            <h6>
              <span className="badge badge-success text-left">Active</span>
            </h6>
          )}
        </div>
      )
    },
    {
      name: "LastUpdateBy",
      selector: "LastUpdateBy",
      sortable: true,
      wrap: true,
      width: "200px"
    },
    {
      name: "LastUpdateDateTime",
      selector: "LastUpdateDateTime",
      sortable: true,
      wrap: true
    }
  ];

  const reloadAddress = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "/api/name/address", {
        params: { namesId: nameId }
      })
      .then(res => {
        setAddressesData(res.data);
      });
  };
  const AddEdit_update = () => {
    if (showAddAddress.addressId === "" || showAddAddress.show === "Add") {
      setAddressFormData({
        namesId: nameId,
        addressType: "",
        address: "",
        telephone: "",
        fax: "",
        remark: "",
        createBy: userId
      });
    } else {
      axios
        .get(
          process.env.REACT_APP_API_URL +
            "/api/name/address/" +
            showAddAddress.addressId
        )
        .then(res => {
          setAddressFormData({
            namesId: nameId,
            addressType: res.data[0].AddressType,
            address: res.data[0].Address,
            telephone: res.data[0].Telephone,
            fax: res.data[0].Fax,
            remark: res.data[0].Remark,
            createBy: userId
          });
        });
    }
  };
  useEffect(() => {
    checkTime();
    document.addEventListener("mousedown",  (e) => { checkTime() });
    axios
      .get(
        process.env.REACT_APP_API_URL + "/api/names/" + props.match.params.id
      )
      .then(res => {
        setFormData({
          name: res.data[0].NamesName,
          code: res.data[0].NamesCode,
          phone: res.data[0].Telephone,
          addr: res.data[0].PostalAddress,
          fax: res.data[0].Fax,
          email: res.data[0].ElectronicMail,
          remark: res.data[0].Remark,
          taxID: res.data[0].TaxID,
          initial: res.data[0].Initial
        });
      });

    reloadAddress();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    AddEdit_update();
    //eslint-disable-next-line
  }, [showAddAddress]);

  const saveAdd = () => {
    if (showAddAddress.show === "Add") {
      axios
        .post(
          process.env.REACT_APP_API_URL + "/api/name/address",
          addressFormData
        )
        .then(res => {
          submitSave(res);
        });
    } else if (showAddAddress.show === "Edit") {
      axios
        .put(
          process.env.REACT_APP_API_URL +
            "/api/name/address/" +
            showAddAddress.addressId,
          addressFormData
        )
        .then(res => {
          submitSave(res);
        });
    }

    const submitSave = res => {
      if (res.data.status === "0") {
        setShowAddAddress({ show: "", showPop: false, addressId: "" });
        setShowConfirmAddress(false);
        setAlert(res.data.msg, "success");
        reloadAddress();
      } else {
        setAlert(res.data.msg, "danger");
        setShowConfirmAddress(false);
      }
    };
  };

  const button_right = () => {
    return (
      <div className="card-body text-right">
        <div>
          <Link to={"/names/edit/" + props.match.params.id} hidden={!pagePermission.IsUpdate} >
            <button className="btn btn-primary ml-2" type="button">
              <i className="fa fa-pencil"></i> Edit
            </button>
          </Link>

          <button
            hidden={!pagePermission.IsDelete}
            className="btn btn-danger ml-2"
            type="button"
            onClick={() => {
              setShowDeleteName(true);
            }}
          >
            <i className="fa fa-remove"></i> Delete
          </button>

          <Link to="/names">
            <button className="btn btn-secondary ml-2" type="button">
              <i className="fa fa-reply"></i> Back
            </button>
          </Link>
        </div>
      </div>
    );
  };

  return (
    <Layout activeLinkTo="/names" menuId="5">
      <div>
        <div className="container-fluid" style={{ minHeight: 500 }}>
          <Alerts />
          {button_right()}
          <div className="card-body">
            <div className="card">
              <div className="card-body">
                <div className="form-group row">
                  <div className="col-md-2">
                    <label className="control-label sbold l-view">Name:</label>
                  </div>
                  <div className="col-md-4">
                    <input
                      readOnly
                      type="text"
                      className="form-control signature form-control-sm"
                      value={formData.name + ' {' + formData.code + '}' || ""}
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="control-label sbold l-view">
                      Telephone:
                    </label>
                  </div>
                  <div className="col-md-4">
                    <input
                      readOnly
                      type="text"
                      className="form-control signature form-control-sm"
                      value={formData.phone || ""}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-2">
                    <label className="control-label sbold l-view">
                      Electronic Mail :
                    </label>
                  </div>
                  <div className="col-md-4">
                    <input
                      readOnly
                      type="text"
                      className="form-control signature form-control-sm"
                      value={formData.email || ""}
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="control-label sbold l-view">Fax :</label>
                  </div>
                  <div className="col-md-4">
                    <input
                      readOnly
                      type="text"
                      className="form-control signature form-control-sm"
                      value={formData.fax || ""}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-2">
                    <label className="control-label sbold l-view">
                      Tax ID : 
                    </label>
                  </div>
                  <div className="col-md-4">
                    <input
                      readOnly
                      type="text"
                      className="form-control signature form-control-sm"
                      value={formData.taxID || ""}
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="control-label sbold l-view">
                      Initial : 
                    </label>
                  </div>
                  <div className="col-md-4">
                    <input
                      readOnly
                      type="text"
                      className="form-control signature form-control-sm"
                      value={formData.initial || ""}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-2">
                    <label className="control-label sbold l-view">
                      Postal Address :
                    </label>
                  </div>
                  <div className="col-md-10">
                    <textarea
                      readOnly
                      className="form-control signature form-control-sm"
                      value={formData.addr}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-2">
                    <label className="control-label sbold l-view">
                      Remark :
                    </label>
                  </div>
                  <div className="col-md-10">
                    <textarea
                      readOnly
                      className="form-control signature form-control-sm"
                      value={formData.remark}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="card">
              <div className="card-body">
                <Tabs>
                  <TabList>
                    <Tab>Addresses</Tab>
                    <Tab>Receivable Balance</Tab>
                  </TabList>
                  <TabPanel>
                    <button
                      hidden={!pagePermission.IsCreate}
                      className="btn btn-success"
                      type="button"
                      onClick={() => {
                        setShowAddAddress({ show: "Add", showPop: true });
                      }}
                    >
                      <i className="fa fa-plus"></i> Add
                    </button>
                    <div className="table-responsive">
                      <DataTable
                        noHeader={true}
                        pagination={true}
                        columns={addressesColumn}
                        data={addressesData}
                      />
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="card">
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-bordered table-sm">
                            <thead>
                              <tr className="table-primary">
                                <th scope="col" colSpan="2"></th>
                                <th scope="col" colSpan="5">
                                  Aged Balance
                                </th>
                                <th scope="col"></th>
                              </tr>
                              <tr className="table-info">
                                <th scope="col">Entity</th>
                                <th scope="col"></th>

                                <th scope="col text-right">Current</th>
                                <th scope="col text-right">1 Period</th>
                                <th scope="col text-right">2 Period</th>
                                <th scope="col text-right">3 Period+</th>
                                <th scope="col text-right">Total</th>

                                <th scope="col text-right">Unallocated Cash</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className="form-control-sm" colSpan="8">
                                  Balance By Currency
                                </td>
                              </tr>
                              <tr>
                                <td className="form-control-sm text-left">
                                  Brainwake Food Co., Ltd.
                                </td>
                                <td className="form-control-sm text-center">
                                  USD
                                </td>
                                <td className="form-control-sm text-right">
                                  0.00
                                </td>
                                <td className="form-control-sm text-right">
                                  0.00
                                </td>
                                <td className="form-control-sm text-right">
                                  1,750.00
                                </td>
                                <td className="form-control-sm text-right">
                                  4,942.00
                                </td>
                                <td className="form-control-sm text-right">
                                  6,692.00
                                </td>
                                <td className="form-control-sm text-right">
                                  0.00
                                </td>
                              </tr>
                              <tr>
                                <td className="form-control-sm" colSpan="8">
                                  Totals In Local Currency
                                </td>
                              </tr>
                              <tr>
                                <td className="form-control-sm text-left">
                                  Brainwake Food Co., Ltd.
                                </td>
                                <td className="form-control-sm text-center">
                                  SGD
                                </td>
                                <td className="form-control-sm text-right">
                                  0.00
                                </td>
                                <td className="form-control-sm text-right">
                                  0.00
                                </td>
                                <td className="form-control-sm text-right">
                                  2,384.86
                                </td>
                                <td className="form-control-sm text-right">
                                  6,745.09
                                </td>
                                <td className="form-control-sm text-right">
                                  9,129.95
                                </td>
                                <td className="form-control-sm text-right">
                                  0.00
                                </td>
                              </tr>
                            </tbody>
                            <tfoot>
                              <tr>
                                <td className="form-control-sm text-left sbold">
                                  Last Receipt:
                                </td>
                                <td
                                  className="form-control-sm text-left"
                                  colSpan="7"
                                >
                                  SGD825.00/USD602.00
                                </td>
                              </tr>
                              <tr>
                                <td className="form-control-sm text-left sbold">
                                  Date:
                                </td>
                                <td
                                  className="form-control-sm text-left"
                                  colSpan="7"
                                >
                                  09-Sep-2019
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </Tabs>
              </div>
            </div>
          </div>
          {button_right()}
        </div>
      </div>
      {/* Modal Delete Name */}
      <Modal
        show={showDeleteName}
        onHide={() => {
          setShowDeleteName(false);
        }}
        centered
      >
        <Modal.Body style={{ textAlign: "center" }}>
          <div
            style={{
              width: 80,
              height: 80,
              borderWidth: 4,
              borderStyle: "solid",
              borderColor: "red",
              borderRadius: "50%",
              position: "relative",
              margin: "13px auto"
            }}
          >
            <span
              style={{
                width: 55,
                height: 4,
                borderRadius: 5,
                position: "absolute",
                backgroundColor: "red",
                top: 36,
                left: 8,
                transform: "rotate(45deg)"
              }}
            ></span>
            <span
              style={{
                width: 55,
                height: 4,
                borderRadius: 5,
                position: "absolute",
                backgroundColor: "red",
                top: 36,
                left: 8,
                transform: "rotate(-45deg)"
              }}
            ></span>
          </div>
          <Modal.Title>Delete Name</Modal.Title>
          <p>Please make sure Once deleted, items cannot be returned.</p>
        </Modal.Body>
        <Modal.Footer style={{ textAlign: "center", display: "unset" }}>
          <button
            className="btn btn-secondary ml-2"
            onClick={() => {
              setShowDeleteName(false);
            }}
          >
            <i className="fa fa-reply"></i> Cancel
          </button>
          <button
            className="btn btn-danger ml-2"
            type="button"
            onClick={() => {
              axios
                .put(
                  process.env.REACT_APP_API_URL + "/api/names/delete/" + nameId,
                  {
                    createBy: userId
                  }
                )
                .then(res => {
                  setAlert(res.data.msg, "danger");
                  props.history.push("/names");
                });
            }}
          >
            <i className="fa fa-trash-o"></i> Continue
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Delete Name*/}

      {/* Modal Delete address */}
      <Modal
        show={showDeleteAdd.showPop}
        onHide={() => {
          setShowDeleteAdd({ addId: "", showPop: false });
        }}
        centered
      >
        <Modal.Header closeButton>
          <div
            style={{
              width: 39,
              height: 39,
              borderWidth: 4,
              borderStyle: "solid",
              borderColor: "red",
              borderRadius: "50%",
              position: "relative"
            }}
          >
            <span
              style={{
                width: 24,
                height: 5,
                position: "absolute",
                backgroundColor: "red",
                top: 13,
                left: 3,
                transform: "rotate(45deg)"
              }}
            ></span>
            <span
              style={{
                width: 24,
                height: 5,
                position: "absolute",
                backgroundColor: "red",
                top: 13,
                left: 3,
                transform: "rotate(-45deg)"
              }}
            ></span>
          </div>
          <Modal.Title style={{ paddingLeft: 13 }}>Delete Address</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Please make sure Once deleted, items cannot be returned.</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary ml-2"
            onClick={() => {
              setShowDeleteAdd({ addId: "", showPop: false });
            }}
          >
            <i className="fa fa-reply"></i> Cancel
          </button>
          <button
            className="btn btn-danger ml-2"
            type="button"
            onClick={() => {
              axios
                .put(
                  process.env.REACT_APP_API_URL +
                    "/api/name/address/delete/" +
                    showDeleteAdd.addId,
                  {
                    createBy: userId
                  }
                )
                .then(res => {
                  setShowDeleteAdd({ addId: "", showPop: false });
                  setAlert(res.data.msg, "danger");
                  reloadAddress();
                });
            }}
          >
            <i className="fa fa-trash-o"></i> Continue
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Delete address*/}

      {/* Modal Add/Edit address */}
      <Modal
        show={showAddAddress.showPop}
        onHide={() => {
          setShowAddAddress({ show: "", showPop: false, addressId: "" });
        }}
        centered
      >
        <Modal.Header closeButton>
          {showAddAddress.show === "Add" && (
            <Modal.Title>Add Address</Modal.Title>
          )}
          {showAddAddress.show === "Edit" && (
            <Modal.Title>Edit Address</Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          <Alerts />
          <div className="form-group col labelPadRight ">
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                Type<span style={{ color: "red" }}> * </span>:
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  //autofocus="true"
                  name="addressType"
                  value={addressType}
                  onChange={AddressOnChange}
                />
              </div>
            </div>
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                Address:
              </label>
              <div className="col-md-9">
                <textarea
                  className="form-control  form-control-sm"
                  name="address"
                  value={address}
                  onChange={AddressOnChange}
                ></textarea>
              </div>
            </div>
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                Telephone:
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="telephone"
                  value={telephone}
                  onChange={AddressOnChange}
                />
              </div>
            </div>
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                Fax:
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control  form-control-sm"
                  name="fax"
                  value={fax}
                  onChange={AddressOnChange}
                />
              </div>
            </div>
            <div className="form-group row col">
              <label className="col-md-3 col-form-label form-control-sm sbold">
                Remark:
              </label>
              <div className="col-md-9">
                <textarea
                  className="form-control  form-control-sm"
                  name="remark"
                  value={remark}
                  onChange={AddressOnChange}
                ></textarea>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger ml-2"
            onClick={() => {
              setShowAddAddress({ show: "", showPop: false, addressId: "" });
            }}
          >
            <i className="fa fa-reply"></i> Cancel
          </button>
          <button
            className="btn btn-success ml-2"
            onClick={() => {
              if (addressType === "") {
                setAlert("name is null! Plese fill", "warning");
              } else {
                setShowConfirmAddress(true);
              }
            }}
          >
            {showAddAddress.show === "Add" && (
              <i className="fa fa-plus"> Add </i>
            )}
            {showAddAddress.show === "Edit" && (
              <i className="fa fa-floppy-o"> Save </i>
            )}
          </button>
        </Modal.Footer>
      </Modal>
      {/* Modal Add/Edit address*/}

      {/* Madal confirm Add/Edit Address */}
      <Modal
        show={showConfirmAddress}
        onHide={() => {
          setShowConfirmAddress(false);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <button
            className="btn btn-danger ml-2"
            onClick={() => {
              setShowConfirmAddress(false);
            }}
          >
            <i className="fa fa-reply"></i> Cancel
          </button>
          <button
            className="btn btn-success ml-2"
            type="button"
            onClick={saveAdd}
          >
            <i className="fa fa-floppy-o"></i> Save
          </button>
        </Modal.Footer>
      </Modal>
      {/* Madal confirm Add/Edit Address */}
    </Layout>
  );
};

export default NameView;
